module.exports = __webpack_public_path__ + "static/media/onboard-step-2.d492e1dd.png";